import { EyeIcon } from 'lucide-react';
import { Reseller as NewReseller, Product } from 'randmar-api-client';
import { Button, ExternalProductCard, ProductCard, ResellerCard } from 'randmarcomps';
import React from 'react';
import { Link } from 'react-router-dom';
import Path from '../../routes/Path';
import Reseller from "../../stores/reseller/Reseller";
import SearchResult, { DocumentSearchResult, ManufacturerBid } from '../../stores/search/SearchResult';
import ProductActions from '../products/ProductActions';
import ResellerActions from '../reseller/ResellerActions';
import ButtonWithActions from '../util/ButtonWithActions';
import DocumentCard from './DocumentCard';
import OpportunityCard from './OpportunityCard';

interface ManufacturerGridItemProps {
  searchResult: SearchResult;
  applicationId: string;
}

export const ManufacturerGridItem: React.FC<ManufacturerGridItemProps> = ({ searchResult, applicationId }) => {
  switch (searchResult.contentType) {
    case 'Document':
      const document = searchResult.content as DocumentSearchResult;
      return (
        <DocumentCard
          document={document}
          documentNumber={document.documentNumber || 'Invalid'}
          applicationId={applicationId}
        />
      );

    case 'Reseller':
      const oldReseller = searchResult.content as Reseller;
      const newReseller = searchResult.newContent as NewReseller;
      return (
        <ResellerCard
          reseller={newReseller}
          link={Path.reseller(applicationId, newReseller.ResellerId ?? '')}
          linkNewTab={false}
          actions={
            <div className="flex">
              <ButtonWithActions buttonText="Actions" backgroundColor="#f1f2f4" color="#363636">
                <ResellerActions reseller={oldReseller} />
              </ButtonWithActions>
            </div>
          }
          mainAction={
            <Button asChild className="w-full sm:w-auto">
              <Link to={Path.reseller(applicationId, newReseller.ResellerId ?? '')}>
                <EyeIcon className="mr-2 h-4 w-4" /> View Reseller
              </Link>
            </Button>
          }
        />
      );

    case 'Opportunity':
      return <OpportunityCard opportunities={searchResult.content as ManufacturerBid} />;

    case 'Product':
      const product = searchResult.newContent as Product;
      if (applicationId !== product.ManufacturerId) {
        return (
          <ExternalProductCard
            product={product}
            viewProductLink={Path.product(applicationId, product.RandmarSKU ?? '')}
          />
        );
      }
      return (
        <ProductCard
          applicationId={applicationId}
          product={product}
          viewProductLink={Path.product(applicationId, product.RandmarSKU ?? '')}
          customAction={
            applicationId === product.ManufacturerId && (
              <ProductActions product={searchResult.content} />
            )
          }
        />
      );

    default:
      return null;
  }
};
